export enum PageType {
  Ad = 'ad',
  EditAd = 'editAd',
  NewAd = 'newAd',
  Search = 'search',
  Shop = 'shop',
}
